import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoVideo from 'eco-design/base/eco-video';
import React from 'react';
import styles from './index.module.scss';

const SectionA3 = ({ pageType = 'normal' }: { pageType: string }) => {
    const { t } = useLang(`theProduct.SectionA3`);
    // 根据页面类型获取对应的标签文案
    let label = t('label');
    if (pageType === 'ultra') {
        label = t('ultra_label');
    } else if (pageType === 'ac') {
        label = t('ac_label');
    }
    let title = t('title');
    if (pageType === 'ultra') {
        title = t('ultra_title');
    } else if (pageType === 'ac') {
        title = t('ac_title');
    }

    let item1_title = t('item1_title');
    if (pageType === 'normal') {
        item1_title = t('item1_title_seris') || t('item1_title');
    }

    let item2_title = t('item2_title');
    if (pageType === 'normal') {
        item2_title = t('item2_title_seris') || t('item2_title');
    }
    let item3_title = t('item3_title');
    if (pageType === 'normal') {
        item3_title = t('item3_title_seris') || t('item3_title');
    }

    return (
        <>
            <EcoSpace hPad="100px" />
            <section className={`${styles.SectionA3} GtmModuleData-section`} data-section-id="SectionA3" data-section-title={t('item1_title')}>
                <div className="pc">
                    <EcoVideo
                        autoPlay={true}
                        loop={true}
                        pc="https://websiteoss.ecoflow.com/upload/video/1745477314553/pc2.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1745313972778/pc22%20(1).jpg"
                    />
                </div>
                <div className="h5">
                    <EcoVideo
                        autoPlay={true}
                        loop={true}
                        h5="https://websiteoss.ecoflow.com/upload/video/1745842250180/step2-(1).mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1745313972778/pc22%20(1).jpg"
                    />
                </div>

                <div className="SectionA3-msg">
                    <div className="SectionA3-msg-in">
                        <div className="SectionA3-label">{label}</div>
                        <div className="SectionA3-title">{title}</div>
                        <div className="SectionA3-list">
                            <div className="SectionA3-item">
                                <div className="SectionA3-item-title">{item1_title}</div>
                                <div className="SectionA3-item-desc">{t('item1_desc')}</div>
                            </div>
                            <div className="SectionA3-item">
                                <div className="SectionA3-item-title">{item2_title}</div>
                                <div className="SectionA3-item-desc">{t('item2_desc')}</div>
                            </div>
                            <div className="SectionA3-item">
                                <div className="SectionA3-item-title">{item3_title}</div>
                                <div className="SectionA3-item-desc">{t('item3_desc')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SectionA3;
